import Vue from 'vue'
import Vuex from 'vuex'
import BusComponent from '@/components/common/Bus'
import { fetchByKey } from '@/api/system/config'
import { fetchList as fetchFieldTypeList } from '@/api/template/fieldType'
const Bus = Vue.extend(BusComponent)
const $bus = new Bus({
  template: '<div></div>'
})

Vue.use(Vuex)

const state = {
  // 登录用户信息
  userInfo: null,
  // 首页
  homePage: null,
  // 菜单
  menuData: {
    // 菜单列表
    list: [],
    // 是否收起
    collapse: false
  },
  // 用户消息
  message: {
    visible: false
  },
  // 字段类型数据
  fieldTypeData: {
    list: [],
    lastQueryTime: null
  }
}

const mutations = {
  // 设置字段数据
  setFieldTypeData (state, value) {
    for (const key in value) {
      state.fieldTypeData[key] = value[key]
    }
  },
  /**
   * 切换菜单状态
   *
   * @param state state
   * @param value 新状态
   */
  switchCollapseMenu (state, value) {
    if (value != null) {
      state.menuData.collapse = value
    } else {
      state.menuData.collapse = !state.menuData.collapse
    }
    window.localStorage.setItem('MENU_STATUS', state.menuData.collapse)
  },
  /**
   * 设置已登录的用户信息
   *
   * @param state state
   * @param data 用户信息
   */
  setUserInfo: (state, data) => {
    state.userInfo = data
  },
  /**
   * 设置首页路由信息
   *
   * @param state state
   * @param homePage 首页
   */
  setHomePage (state, homePage) {
    state.homePage = homePage
  },
  /**
   * 重置菜单
   *
   * @param state state
   */
  resetMenus: (state) => {
    state.menuData.list = []
  },
  /**
   * 打开消息窗口
   * @param state state
   */
  openUserMessageWindow (state) {
    state.message.visible = true
  },
  /**
   * 关闭消息窗口
   * @param state state
   */
  closeUserMessageWindow (state) {
    state.message.visible = false
  }
}
const actions = {
  /**
   * 初始化解析模块函数
   */
  initParseModuleFunction () {
    fetchByKey('PARSE_MODULES')
      .then(data => {
        try {
          eval(data.value)
        } catch (e) {
          $bus.$tip.warning('解析模块脚本存在错误')
          console.error(e)
        }
      })
      .catch(e => {
        $bus.$tip.apiFailed(e)
      })
  },
  /**
   * 初始化解析模块字段函数
   */
  initParseFieldFunction () {
    fetchByKey('PARSE_FIELDS')
      .then(data => {
        try {
          eval(data.value)
        } catch (e) {
          $bus.$tip.warning('解析模块字段脚本存在错误')
          console.error(e)
        }
      })
      .catch(e => {
        $bus.$tip.apiFailed(e)
      })
  },
  /**
   * 初始化解析模块字段数据函数
   */
  initParseFieldRowsFunction () {
    fetchByKey('PARSE_FIELD_ROWS')
      .then(data => {
        try {
          eval(data.value)
        } catch (e) {
          $bus.$tip.warning('解析模块字段数据脚本存在错误')
          console.error(e)
        }
      })
      .catch(e => {
        $bus.$tip.apiFailed(e)
      })
  },
  // 初始化字段类型数据
  initFieldTypes ({ state, commit }) {
    // 1000以内不做重新查询，防止连续的FieldTypeSelect组件再频繁使用时出现连续调用接口的情况
    if (state.fieldTypeData.lastQueryTime != null) {
      if (new Date().getTime() - state.fieldTypeData.lastQueryTime < 1000) {
        return
      }
    }
    // 修改最后查询时间
    commit('setFieldTypeData', {
      lastQueryTime: new Date().getTime()
    })
    // 查询数据
    fetchFieldTypeList({
      page: 1,
      capacity: 10000,
      model: {}
    })
      .then(data => {
        const fieldTypes = data.records.map(item => {
          // 非对象类型
          if (item.category !== 'OBJECT') {
            return {
              label: item.label,
              value: item.id,
              variable: item.variable,
              type: item.category
            }
          }
          // 对象类型，选中对象字段配置
          return {
            label: item.label,
            value: item.id,
            variable: item.variable,
            type: item.category,
            children: JSON.parse(item.fieldConfig).map(itemField => {
              return {
                label: itemField.label,
                value: itemField.variable,
                variable: itemField.variable,
                type: itemField.type,
                typeId: item.id
              }
            })
          }
        })
        commit('setFieldTypeData', {
          list: fieldTypes
        })
      })
  }
}
const getters = {
  // 根据字段获取字段类型
  getFieldTypeByField (state, field) {
    return (field) => {
      for (const fieldType of state.fieldTypeData.list) {
        // 对象类型
        if (fieldType.type === 'OBJECT') {
          for (const subType of fieldType.children) {
            if (subType.label === field.label) {
              return subType
            }
          }
          continue
        }
        // 非对象类型
        if (fieldType.label === field.label) {
          return fieldType
        }
      }
      return null
    }
  }
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
